export default "__VITE_ASSET__BzKaFF3P__"